import { useCallback, useState } from "react";
import LogoMini from "../../../components/icons/LogoMini";
import PlayTriangle from "../../../components/icons/PlayTriangle";
import "../general.scss";
import "./index.scss";
import Popup from "../../../components/Popup";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useData } from "../../../context/DataProvider";
import PMS from "../../../assets/img/SolutionsIcons/AgilysysPMS.svg";
import { Header } from "../../../components/Header";

const PMSFPage = () => {
    const [showVideo, setShowVideo] = useState<boolean>(false);
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    return(
        <div className="page splash PMSFPage">
            <div className="page-title"><img src={PMS} alt="" /></div>
            <Header />
            <div className="text-blocks">
                <div className="std-text">
                Agilysys delivers the industry's most modern, robust and
innovative PMS solutions aligned with property preferences
to preserve the power to choose. From an individual
location to an enterprise chain, get the most modern,
comprehensive property management solutions for
managing your hospitality business.
                </div>
            </div>
            <div className="play-video" onClick={()=>{
                _logEvent('click', "Solutions - PMS", "Play Video");
                addFlow("Play Video");
                setShowVideo(true)}}>
                <PlayTriangle />
                Play Video
            </div>
            <img className="img-1" src={"https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/PMS1.png"} alt="" />
            <Popup showPopup={showVideo} setShowPopup={()=>setShowVideo(false)} disableOffClick={true}>
                <>{showVideo && <video 
                autoPlay
                controls
                src={"https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/videos/InteractivePMS2.mp4"} />}</>
            </Popup>
        </div>
    )
}

export default PMSFPage;